import { Consent } from '@/types/typesInterfaces';
import { performConsent } from '@/utils/client/client_api';
import { Checkbox, CheckedOptions } from '@habacuscode/habacus_ui_component_library';
import React, { useState, useEffect } from 'react';
import Loading from './Loading';
import { useTranslations } from 'next-intl';


export interface PrivacyOptionsProps {
  consents: Array<Consent>;
  onChange: (e: Array<Consent>) => void;
}

const PrivacyOptions = ({ consents, onChange }: PrivacyOptionsProps) => {
  const tCommon = useTranslations('Common');
  const [consentsCategories, setConsentsCategories] = useState<Array<string> | null>(null);
  const [consentsCatalogue, setConsentsCatalogue] = useState<Array<Consent> | null>(null);

  const performGetConsents = async () => {
    const responseConsent = await performConsent();

    if (responseConsent.isOk && responseConsent.response) {
      const all: Consent = {
        id: "all",
        text: tCommon('privacyCheckAll'),
        title: "",
        mandatory: false,
        checked: false,
        category: 'UNCATEGORIZED'
      };

      const data = [all].concat(responseConsent.response);

      setConsentsCategories(Array.from(new Set(data.map((consent: Consent) => consent.category))));
      setConsentsCatalogue(data);
    } else {
      console.error(responseConsent);
    }
  }

  useEffect(() => {
    performGetConsents();
  }, [])

  // Handle individual checkbox changes
  const handleChange = (selectedItem: CheckedOptions, checkedValue?: boolean) => {
    if (consentsCatalogue === null) {
      return;
    }

    const newConsents: any = [...consentsCatalogue];
    for (let i = 0; i < newConsents.length; i++) {
      if (newConsents[i].id == selectedItem.id) {
        const newValue = checkedValue ?? !newConsents[i].checked;
        newConsents[i].checked = newValue;

        if (i == 0) {
          newConsents.forEach((_: Consent, idx: number) => newConsents[idx].checked = newValue);
        } else {
          newConsents[0].checked = newConsents.every((consent: Consent, j: number) => j === 0 || consent.checked);
        }
        break;
      }
    }

    setConsentsCatalogue(newConsents)
    onChange(newConsents)
  };


  // Format text with ink if linkText is provided
  const formatText = (option: Consent) => {
    if (!option.linkText) return option.text;

    const parts = (option.text as string).split(option.linkText);
    return (
      <>
        {parts[0]}
        <a href={option.linkUrl} className="text-blue-950 underline">
          {option.linkText}
        </a>
        {parts[1]}
      </>
    );
  };

  if (consentsCatalogue === null) {
    return <Loading />;
  }

  const mappingNameCategories = (category: string) => {
    switch (category) {
      case 'PRIVACY':
        return 'Privacy';
      case 'TRASPARENCE':
        return 'Trasparenza';
      default:
        return '';
    }
  }

  return (
    <div className="w-full mx-auto py-4 px-0 md:px-4 rounded-lg text-md">
      {consentsCategories?.map((category: string) => (
        <div key={category} className="mb-2">
          {category != 'UNCATEGORIZED' && <h3 className="font-semibold mb-2">{mappingNameCategories(category)}</h3>}
          <div className="space-y-2">
            <Checkbox
              key={category}
              items={
                consentsCatalogue
                  .filter((consent: Consent) => consent.category === category)
                  .map((consent: Consent): CheckedOptions => ({
                    id: consent.id,
                    checked: consent.checked,
                    title: consent.title,
                    text: consent.text as string,
                    mandatory: consent.mandatory
                  }))
              }
              id={`checkbox-${category}`}
              onChange={(selectedItem: CheckedOptions) => handleChange(selectedItem)}
              className={"container-checkbox"}
              highlightFirst={category == 'UNCATEGORIZED'}
            />
          </div>
        </div>
      ))
      }
    </div>
  );
};

export default PrivacyOptions;